import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-forest text-cream pt-20 pb-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16 border-b border-cream/15">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-cream flex items-center justify-center">
                <span className="text-forest font-serif text-2xl leading-none">G</span>
              </div>
              <div>
                <div className="font-serif text-2xl text-cream">Greenroute</div>
                <div className="uppercase text-[10px] tracking-[0.25em] text-cream/70">
                  Estate Management Services
                </div>
              </div>
            </div>
            <p className="text-cream/75 mt-6 max-w-md leading-relaxed">
              Managed with precision. Built on trust. A South African estate
              management partner committed to preserving value, ensuring safety,
              and fostering thriving communities.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="uppercase text-[10px] tracking-[0.3em] text-gold mb-5">
              Explore
            </div>
            <ul className="space-y-3 text-cream/85">
              <li><a href="/#services" className="link-underline">Services</a></li>
              <li><a href="/#about" className="link-underline">About</a></li>
              <li><a href="/#why" className="link-underline">Why Us</a></li>
              <li><a href="/blog" className="link-underline">Insights</a></li>
              <li><a href="/#sustainability" className="link-underline">Sustainability</a></li>
              <li><a href="/#contact" className="link-underline">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="uppercase text-[10px] tracking-[0.3em] text-gold mb-5">
              Get in touch
            </div>
            <ul className="space-y-4 text-cream/85 text-sm">
              <li className="flex items-start gap-3">
                <Phone size={16} className="mt-0.5 shrink-0 text-gold" />
                <a href="tel:+27661833893" className="link-underline">+27 66 183 3893</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="mt-0.5 shrink-0 text-gold" />
                <a href="mailto:admin@green-route.co.za" className="link-underline">admin@green-route.co.za</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 shrink-0 text-gold" />
                <span>Cnr John & Earp Street, Selby,<br />Johannesburg, 2001</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 pt-8 text-xs text-cream/55">
          <div>
            © {new Date().getFullYear()} Greenroute Estate Management Services (Pty) Ltd. All rights reserved.
          </div>
          <div className="flex gap-6">
            <span>Reg. No. 2024/369346/07</span>
            <a href="/admin/login" className="link-underline" data-testid="admin-link">Admin</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
